import React from "react";
import PropTypes from "prop-types";
import { throttle } from "lodash";

import { ToastContainer } from "react-toastify";
import { Zoom } from "./Zoom";
import { Undo } from "./Undo";
import { ProtocolScene } from "../ProtocolScene";
import { TaskTracker } from "../ProtocolOptions/components/TaskTracker"
import { mapDataToTasks } from './TaskDataImporter'

import {
  start,
  drag,
  end,
  setDragImage,
  getTarget
} from "./DragFunctions"

import "./style.scss";

const DIMENSIONS = {
  width: 1515,
  height: 900,
};

export class ProtocolView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      userScale: 1,
      sceneScale: 1,
      objCurrent: null,
      objPrevious: null
    };
  }

  componentWillMount(){

    this.props.setupProtocolScene({})

    const interactions = (heldObj, target) => {
      //Sets target of last drop for Pipette extraction/deposit
      this.props.setLastDrop({
        lastHeld: heldObj,
        lastTarget: target
      })
    }

    Object.defineProperty(interactions, 'name', {value: ('scene_interactions'), configurable: true});
    this.props.pushInteractions([interactions])

    // {level, data}
    this.props.setTaskPages(mapDataToTasks(1, this.props.sequence))
  }

  componentDidMount() {
    // Resize the scene and attach the resize method to the window resize event
    this.handleResize();
    window.addEventListener("resize", this.handleResize);

    var temp = document.getElementsByClassName("dropTarget")
    this.props.setTargetList(temp)
  }

  componentDidUpdate(prevProps, prevState){
    if(
      typeof prevProps.heldObject !== 'undefined' &&
      this.props.heldObject.htmlObj == null &&
      prevProps.heldObject.type != null
    ){
      this.runInteractions(prevProps.heldObject)
    }
    if(this.state.userScale !== prevState.userScale){
      this.handleResize()
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  getObjectFromId = (id) => {
    if (id === undefined || id === null) {
      return null
    }
    const idArr = id.split("_")
    let obj = {
      type: "",
      id: -1,
      subId: -1,
      subRef: -1,
      solution: "",
      tipType: ""
    }
    // console.log('idArr', idArr);
    switch (idArr[0]) {
      case "P20":
      case "P100":
      case "P200":
      case "P1000":
        obj.type = "Pipette"
        obj.id = idArr[1]
        break;
      case "Solution":
        obj.type = "Solution"
        obj.id = idArr[1]
        obj.solution = this.props.solutions[obj.id - 1].type
        break;
      case "BlottingPaper":
        obj.type = "BlottingPaper"
        obj.id = idArr[1]
        obj.subId = idArr[2]
        break;
      case "Trash":
        obj.type = "Trash"
        obj.id = idArr[1]
        break;
      case "PipetteRack":
        obj.type = "PipetteRack"
        break;
      case "TubeStand":
        obj.type = "TubeStand"
        break;
      case "AgaroseGel":
        obj.type = "AgaroseGel"
        obj.id = idArr[1]
        break;
      case "GelBox":
        obj.type = "GelBox"
        obj.id = idArr[1]
        obj.subId = idArr[2]
        break;
      case "PowerSupplyLead":
        obj.type = "PowerSupplyLead"
        obj.id = idArr[1]
        obj.subId = idArr[2]
        obj.subRef = parseInt(idArr[4], 10)
        break;
      case "PowerSupply":
        obj.type = "PowerSupply"
        obj.id = idArr[1]
        obj.subId = idArr[2]
        obj.subRef = parseInt(idArr[3], 10)
        break;
      case "Flask":
        obj.type = "Flask"
        obj.id = idArr[1]
        break;
      case "Transilluminator":
        obj.type = "Transilluminator"
        obj.id = idArr[1]
        break;
      case "IceBucket":
        obj.type = "IceBucket"
        obj.id = idArr[1]
        break;
      case "Thermocycler":
        obj.type = "Thermocycler"
        obj.id = idArr[1]
        break;
      case "HeatBlock":
        obj.type = "HeatBlock"
        obj.id = idArr[1]
        break;
      case "FloatingTubeRack":
        obj.type = "FloatingTubeRack"
        obj.id = idArr[1]
        break;
      case "WaterBath":
        obj.type = "WaterBath"
        obj.id = idArr[1]
        break;
      case "Microcentrifuge":
        obj.type = "Microcentrifuge"
        obj.id = idArr[1]
        break;
      default:
        break;
    }
    if (idArr[1] === "TipBox") {
      obj.type = "TipBox"
      obj.id = idArr[2]
      obj.tipType = idArr[0]
    }
    obj.id = parseInt(obj.id)
    return obj
  }

  //Runs all interaction functions that have been added to the global array
  runInteractions = (heldObj) => {
    const target = getTarget(heldObj.htmlObj, this.props.targetList, this.state.userScale, this.state.sceneScale).id
    console.log('target protocolView: ', target);

    //if(target){
      this.props.interactions.forEach(interaction => {
        interaction(heldObj, this.getObjectFromId(target))
      });
    //}

    //interaction function structure
    //always takes 'target' arg -> what the component will be interacting with
    //function must internally get access to all states it needs
  }

  wrapperClass = () => {
    const classList = [
      "protocol-view",
      this.props.drawerOpen ? "drawer-active" : "",
    ];
    return classList.join(" ");
  };

  handleResize = () => {
    this.setState({
      sceneScale:
        ((window.innerHeight - 6) / DIMENSIONS.height) * this.state.userScale,
    }, ()=>this.props.setSceneScale({scale: this.state.sceneScale}));
  };

  onDragStart = (e) => {

    // //Delete when working
    // var temp = document.getElementsByClassName("dropTarget")
    // this.props.setTargetList(temp)
    //

    this.setState({
      objCurrent: e.target
    })

    setDragImage(e)
    start(e, e.target, this.state.sceneScale, this.state.userScale)

  }

  onDragOver = throttle((e) => {
     e.preventDefault();
     drag(e, this.state.objCurrent, this.state.userScale, this.state.sceneScale);
   }, 10);


  //Check heldObj to {obj: pipette, id: ID}
  //Set held to false in target pipette
  //Set heldObj to null
  onDrop = (e) => {
    e.preventDefault()

    //Clear held object
    this.props.setHeldObject({
      type: null,
      id: -1,
      htmlObj: null,
    })

    end(e, this.state.objCurrent, this.state.objPrevious)

    if(this.state.objCurrent !== null){
      this.setState({
        objPrevious: this.state.objCurrent
      })
    }

    this.setState({
      objCurrent: null
    })
  }

  render() {
    return (
      <div className={this.wrapperClass()}>
        <div className="protocol-view__left-box">
          {/*<h1 className='protocol-view__title'>{this.props.title}</h1>*/}
          {/*<p className='protocol-view__description'>{this.props.description}</p>*/}
          <div
            id="scene"
            style={{
              transform: "scale(" + this.state.userScale + ")",
              width: "100%",
              height: "100%",
              transformOrigin: "top left",
              position: "absolute",
            }}
          >
            {/* ----- Drag and Drop Scene ------ */}
            <div
              id="dragdrop"
              style={{
                //border: "5px solid red",
                //boxSizing: "border-box",
                width: DIMENSIONS.width + "px",
                height: DIMENSIONS.height + "px",
                transform: "scale(" + this.state.sceneScale + ")",
                transformOrigin: "top left",
              }}
              onDragStart={this.onDragStart}
              onDragOver={(e)=>{
                e.persist();
                this.onDragOver(e);
              }}
              onDragEnd={this.onDrop}
            >
              <ProtocolScene
                apparatus={this.props.apparatus}
                userScale={this.state.userScale}
                sceneScale={this.state.sceneScale}
              />
              <TaskTracker />
            </div>
          </div>

          {/* ----- UI Elements ------ */}
          <ToastContainer closeButton={false} role={"dialog"} />
          <Zoom
            scale={this.state.userScale}
            setSceneScale={(scale) =>
              this.setState({
                userScale: scale.scale,
              }, ()=>this.props.setUserScale({scale: this.state.userScale}))
            }
          />
          <Undo setModal={this.props.setModal} undoAttempts={this.props.undoAttempts} />
        </div>
      </div>
    );
  }
}

ProtocolView.propTypes = {
  drawerOpen: PropTypes.bool,
  title: PropTypes.string,
  sceneType: PropTypes.string,
  description: PropTypes.string,
};
